export function initDatesHours() {
  const ctaBtn = document.querySelector(".dates-hours__cta");
  if (!ctaBtn) return;

  ctaBtn.addEventListener("click", (e) => {
    e.preventDefault();
    downloadCalendarEvent();
  });
}

function buildVEvent({ uid, dtStart, dtEnd, summary, description }) {
  return [
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTART:${dtStart}`,
    `DTEND:${dtEnd}`,
    `SUMMARY:${summary}`,
    `DESCRIPTION:${description}`,
    "END:VEVENT",
  ].join("\r\n");
}

function downloadCalendarEvent() {
  const events = [
    buildVEvent({
      uid: "mecs-2026-day1@middleeastcoatingshow.com",
      dtStart: "20260928T060000Z",
      dtEnd: "20260928T140000Z",
      summary: "Middle East Coating Show 2026 — Day 1",
      description: "Monday · 10:00 AM – 6:00 PM",
    }),
    buildVEvent({
      uid: "mecs-2026-day2@middleeastcoatingshow.com",
      dtStart: "20260929T060000Z",
      dtEnd: "20260929T140000Z",
      summary: "Middle East Coating Show 2026 — Day 2",
      description: "Tuesday · 10:00 AM – 6:00 PM",
    }),
    buildVEvent({
      uid: "mecs-2026-day3@middleeastcoatingshow.com",
      dtStart: "20260930T060000Z",
      dtEnd: "20260930T110000Z",
      summary: "Middle East Coating Show 2026 — Day 3",
      description: "Wednesday · 10:00 AM – 3:00 PM",
    }),
  ];

  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Middle East Coating Show//MECS 2026//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    ...events,
    "END:VCALENDAR",
  ].join("\r\n");

  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = "mecs-2026.ics";
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
